module.exports = __webpack_public_path__ + "d2103726cf6d7ad48371e91cb273e4db.ico";